import { Img } from 'react-image';
import { useLocation } from 'react-router-dom';

const AuthSideInfo = () => {
	const location = useLocation();
	const signInurl = location.pathname?.split('?')[0];
	const data = [
		[
			'/assets/smallcase_logo.svg',
			'/assets/dream11_logo.svg',
			'/assets/airmeet_logo.svg',
			'/assets/IBM_logo.svg',
			'/assets/Ajio_logo.svg',
			'/assets/salesken_logo.svg',
		],
		[
			'/assets/urban_piper.svg',
			'/assets/cap_gemini.svg',
			'/assets/pagar_book.svg',
			'/assets/vyapar_logo.svg',
			'/assets/swiggy_logo.svg',
			'/assets/bharatPe_logo.svg',
		],
		[
			'/assets/ola.svg',
			'/assets/leap_finance.svg',
			'/assets/BharatAgri_logo.svg',
			'/assets/shareChat_logo.svg',
			'/assets/eatFit_logo.svg',
			'/assets/home_lane.svg',
		],
	];

	const pointersData = [
		{
			title: 'Holistic Support',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/point_1_1cb4e76cf5.png',
			description: 'End-to-end support for job seekers, from assessment to job opportunities.',
		},
		{
			title: 'Placement Preparation',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/point_2_4ce498a916.png',
			description: 'Tailored master classes on key skills like interviews, aptitude, and personal branding.',
		},
		{
			title: 'Exclusive Job Access',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/point_3_5d20a6daa0.png',
			description: 'Gain entry to exclusive job opportunities and placement drives by Masai.',
		},
	];

	return (
		<div
			className={'w-[100%] overflow-hidden flex flex-col justify-between dark:bg-[#1f3343] relative isolate bg-white'}
		>
			<img
				alt=""
				className="absolute w-full h-full z-[-1] object-cover"
				src="https://masai-website-images.s3.ap-south-1.amazonaws.com/auth_bg_00f757f54a.png"
			/>
			{(signInurl === '/auth/signin' ||
				signInurl === '/auth/register' ||
				signInurl === '/auth/email-verification' ||
				signInurl === '/auth/phone-verification' ||
				signInurl === '/auth/change-phone' ||
				signInurl === '/auth/change-email') && (
				<div className="flex flex-col sm:hidden isolate">
					<div className="max-w-[90%] mx-auto">
						<div className="text-[54px] font-inter font-[700] text-[#1F3343] dark:text-[#fff] leading-[56px] mt-[50px] ">
							Ready to get your dream
							<span className="greenish-gradient-text"> job</span>
							<p className="pt-6 font-inter text-lg font-[500] text-[#555770] dark:text-[#c7c9d9]">
								Sign up now and start your job seeking journey with our help.
							</p>
						</div>
						<div className="flex flex-col gap-8 xl:pl-8 py-8 max-w-[584px]">
							{pointersData.map((pointer, index) => (
								<div key={index} className="flex items-start gap-4">
									<img className="min-w-[48px] min-h-[48px] w-[48px] h-[48px]" src={pointer.icon} alt={pointer.title} />
									<div>
										<h3 className="text-lg font-inter font-[700] text-[#28293D]">{pointer.title}</h3>
										<p className="text-sm font-inter font-[500] text-[#555770]">{pointer.description}</p>
									</div>
								</div>
							))}
						</div>

						<img
							src="https://masai-website-images.s3.ap-south-1.amazonaws.com/bg_gradiant_abe6e9e32e.png"
							alt=""
							className="absolute bottom-0 pointer-events-none inset-x-0 z-[-1] w-full h-[369.32px] max-h-[369.32px] max-w-[398px] mx-auto"
						/>
						<div className="relative m-auto mx-[-10%] mt-10 box-border flex flex-col gap-7 overflow-hidden h-[240px] max-h-[340px] isolate">
							<div className="pointer-events-none absolute inset-0 z-[1] w-full h-full [background:_linear-gradient(270deg,_#FFF_6.61%,_rgba(255,_255,_255,_0.00)_29.66%,_rgba(255,_255,_255,_0.00)_73.89%,_#FFF_96.48%)]"></div>
							{data.map((marquee, index) => (
								<div key={index} className="marquee">
									<ul className={index % 2 === 0 ? 'marquee-content' : 'marquee-content_left_to_right'}>
										{marquee.map((imgUrl, imgIndex) => (
											<li key={imgIndex}>
												<Img className="rounded-2xl" src={imgUrl} width="188" height="64" alt={imgUrl} />
											</li>
										))}
									</ul>
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default AuthSideInfo;
